import '.f{width:100%;}.ssr-plugin'
import '.g8{padding:12px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import { ReactNode } from 'react'
import { Icon, IconProps } from '../Icon/index.js'
import { radius } from '../../utils/radius.js'
import { Text } from '../Text/index.js'
import { Color, colors } from '../../tokens/colors.js'
import { Style, styled } from 'inlines'

type NoteProps = {
  title: string
  description?: string
  icon?: IconProps['variant']
  children?: ReactNode
  color?: 'neutral' | 'orange' | 'red' | 'green' | 'purple'
  style?: Style
}

export const Note = ({
  title,
  description,
  color = 'neutral',
  icon = 'error',
  children,
  style,
}: NoteProps) => {
  return (
    <styled.div className="f g8 a d2 d"
      style={{
        borderRadius: radius[20],
        boxShadow: `inset 0 0 0 1px ${color !== 'neutral' ? colors[color + '20'] : colors.neutral20Adjusted}`,
        color: color !== 'neutral' ? colors[`${color}100`] : colors.neutral80,
        background:
          color !== 'neutral' ? colors[`${color}10`] : colors.neutral10Adjusted,
        ...style,
      }}
    >
      {icon && <Icon variant={icon} color="inherit" />}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 0,
        }}
      >
        <Text selectableText={false} variant="display-medium" color="inherit">
          {title}
        </Text>
        {description && (
          <Text
            selectableText={false}
            variant="display-regular"
            color={
              {
                neutral: 'neutral60',
                red: 'red80',
                orange: 'orange100',
                green: 'green80',
                purple: 'purple80',
              }[color] as Color
            }
          >
            {description}
          </Text>
        )}
      </div>
      {children && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 'auto',
            gap: 8,
          }}
        >
          {children}
        </div>
      )}
    </styled.div>
  )
}

export type { NoteProps }
